export default __webpack_public_path__ + "static/media/Layer_6@2x.3679f5f1.png";